import './SignUp.less';

export const prefix = 'bm-c-sign-up';

export { default } from './SignUp';
